import React from 'react'
import { useLocation } from 'react-router-dom'
import { useIsTabletOrMobile } from 'lib/shared/hooks/responsive'
import { useListrakPageBrowse, useListrakCartActivity } from 'modules/listrak'
import { useJustunoCart } from 'modules/justuno'
import { DesktopVersion } from './components/DesktopVersion'
import { MobileVersion } from './components/MobileVersion'
import { useStoreView } from 'hooks/useStoreView'

export const Header = () => {
  const { pathname } = useLocation()
  const isMobile = useIsTabletOrMobile()
  const { isSofiaAndGrace } = useStoreView()
  const isProductSelector = isSofiaAndGrace ? pathname.includes('product-selector/questions') || pathname.includes('product-selector/results') : pathname.includes('product-selector')
  useListrakCartActivity()
  useListrakPageBrowse()
  useJustunoCart()

  if (isProductSelector) {
    return null
  }

  return (
    <>
      {isMobile ? (
        <MobileVersion />
      ) : (
        <DesktopVersion />
      )}
    </>
  )
}
